import { DefaultState, DropdownItem } from 'store/types';

export const REQUESTS_BY_CLIENT_FILTERS_REQUEST = 'REQUESTS_BY_CLIENT_FILTERS_REQUEST';
export const REQUESTS_BY_CLIENT_FILTERS_SUCCESS = 'REQUESTS_BY_CLIENT_FILTERS_SUCCESS';
export const REQUESTS_BY_CLIENT_FILTERS_FAILURE = 'REQUESTS_BY_CLIENT_FILTERS_FAILURE';

export interface RequestsByClientFiltersData {
  dates: Array<DropdownItem>;
}

export type RequestsByClientFiltersState = DefaultState & {
  contents?: RequestsByClientFiltersData;
};

interface RequestsByClientFiltersRequest {
  type: typeof REQUESTS_BY_CLIENT_FILTERS_REQUEST;
}

interface RequestsByClientFiltersSuccess {
  type: typeof REQUESTS_BY_CLIENT_FILTERS_SUCCESS;
  contents: RequestsByClientFiltersData;
}

interface RequestsByClientFiltersFailure {
  type: typeof REQUESTS_BY_CLIENT_FILTERS_FAILURE;
}

export type RequestsByClientFiltersActionTypes =
  | RequestsByClientFiltersRequest
  | RequestsByClientFiltersSuccess
  | RequestsByClientFiltersFailure;
